import { Button, Carousel } from "antd";
import {
  BsArrowRightShort,
} from "react-icons/bs";
import { Link } from "react-router-dom";
import styles from "../LandingV2.module.scss";

import check_every_item from "../images/check_every_item.webp";
import desi_hands from "../images/desi_hands.webp";
import think_green from "../images/think_green.webp";

export const BringChangeSlider = () => {
  return (
    <div className="p-0 mt-5">
      <div className="container see_more_title d-flex align-items-center justify-content-between mt-4">
        <h2>Together, Let's bring change</h2>
        <div className="text-primary">
          <span>See More</span>
          <BsArrowRightShort size={20} />
        </div>
      </div>
      <Carousel
        autoplay
        dots={false}
        draggable
        slidesToShow={3}
        slidesToScroll={1}
        responsive={[
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ]}
      >
        <div className="pe-4 ps-4 ps-sm-0 position-relative">
          <img
            src={check_every_item}
            alt="banner"
            className="img-fluid"
            loading="lazy"
          />
          <Link
            to={"/quality-authenticity"}
            className={`position-absolute start-50 translate-middle ${styles.read_more_btn}`}
          >
            <Button type="primary" size="large">
              <div className="d-flex align-items-center gap-2">
                <span>Read More</span>
                <BsArrowRightShort color="white" size={26} />
              </div>
            </Button>
          </Link>
        </div>
        <div className="pe-4 ps-4 ps-sm-0 position-relative">
          <img
            src={think_green}
            alt="banner"
            className="img-fluid"
            loading="lazy"
          />
          <Link
            to={"/think-green"}
            className={`position-absolute start-50 translate-middle ${styles.read_more_btn}`}
          >
            <Button type="primary" size="large">
              <div className="d-flex align-items-center gap-2">
                <span>Read More</span>
                <BsArrowRightShort color="white" size={26} />
              </div>
            </Button>
          </Link>
        </div>
        <div className="pe-4 ps-4 ps-sm-0 position-relative">
          <img
            src={desi_hands}
            alt="banner"
            className="img-fluid"
            loading="lazy"
          />
          <Link
            to={"/desi-hands"}
            className={`position-absolute start-50 translate-middle ${styles.read_more_btn}`}
          >
            <Button type="primary" size="large">
              <div className="d-flex align-items-center gap-2">
                <span>Read More</span>
                <BsArrowRightShort color="white" size={26} />
              </div>
            </Button>
          </Link>
        </div>
      </Carousel>
    </div>
  );
};
